window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
var slickRun = require('./slick-ext');
var productTileKeyboardNav = require('./product/productTileKeyboardNav');
require('jquery.cookie');

/**
 * SITE-WIDE ACCESSIBILITY OBJECT
 *
 * Provides a global namespace for accessibility-related functions
 * and properties used throughout the site.
 *
 * @namespace SiteAccessibility
 */
window.SiteAccessibility = window.SiteAccessibility || {};
// Track the element that triggered the modal for focus restoration
SiteAccessibility.lastTriggerButton = null;

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('janieandjack/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('./components/toolTip'));
    processInclude(require('mirakl/components/miraklNotification'));
    //initCartRecommendations();
    //initCartEmptyRecommendations();
    initSliders();
    initPopovers();
    initRecaptchaCheck();
    floatingBoxInit();
    rotatingBannerInit();
    initDynamicErrorsAlert();
    
    // Initialize keyboard navigation for product tiles
    var keyboardNav = productTileKeyboardNav();
    keyboardNav.init();
});

require('./thirdParty/bootstrap');
require('base/components/spinner');
require('slick-carousel');

function initSliders() {
    $(".grid-tile:not(:has(*))").remove();
    slickRun.horizontalSlider();
    slickRun.heroSlider();
}

function initCartRecommendations() {
    if (!$('.cart-recommendations .product-recom-slider .product-horizontal-carousel').hasClass('slick-initialized')) {
        slickRun.productRecomSlider(3);
    }
}

function initCartEmptyRecommendations() {
    if (!$('.cart-empty-recommendations .product-recom-slider .tiles-container').hasClass('slick-initialized')) {
        slickRun.productRecomSlider(3);
    }
}

function initPopovers(){
    // init all bootstrap popovers
    $('[data-toggle="popover"]').popover();
    $("html").on("mouseup", function (e) {
        var l = $(e.target);
        if (!l[0].class || l[0].className.indexOf("popover") == -1) {
            $(".popover").each(function () {
                $(this).popover("hide");
            });
        }
    });
}

function initRecaptchaCheck() {
    if($('.g-recaptcha').length > 0){
        $('.g-recaptcha').each(function(e){
            var $recaptchaDiv = $(this);
            var $buttonselector = $(this).data('submitbutton');
            var $buttonEle = $('#' + $buttonselector);
            $buttonEle.on('click', function (e) {
                var	$error = $('#recaptcha-verify-error_'+$buttonselector);
                var captcha = $recaptchaDiv.find('.g-recaptcha-response').val();
                if (captcha.length == 0){
                    e.preventDefault();
                    var error;
                    error = $error.find('span.error');
                    if (error.length === 0) {
                        error = $('<span>').addClass('error').appendTo($error);
                    }
                    error.html(Resources.VALIDATE_CAPTCHA);
                    $error.show();
                    return;
                } else {
                    $error.hide();
                }
            });
        });
    }
}

function floatingBoxInit() {
    var box = $('.floating-box'),
        isBoxCookieSet = $.cookie('floatingBox'),
        scrollTrigger = 400;

    if (box.length && !isBoxCookieSet) {
        $(window).on('scroll', function () {
            floatingBoxShow();
        });

        box.on('click', '.close', function (e) {
            e.preventDefault();

            $.cookie('floatingBox', null, {path: '/'});
            $.cookie('floatingBox', 'assetclose', {path: '/'});

            $('body').removeClass('with-floatingBox');
            box.remove();
        })
    } else {
        box.remove();
    }

    var floatingBoxShow = function () {
        var box = $('.floating-box');

        if (box.length) {
            var scrollTop = $(window).scrollTop();

            if (scrollTop > scrollTrigger) {
                box.addClass('active');
                $('body').addClass('with-floatingBox');
            } else {
                box.removeClass('active');
                $('body').removeClass('with-floatingBox');
            }
        }
    }
}


function rotatingBannerInit() {
    var rotationInterval = SitePreferences.GLOBAL_BANNER_SPEED,
        customCSSFile = $('.rotatingBannerOptions').data('cssfile');

    // load custom CSS
    if (customCSSFile) {
        util.loadCssFile(customCSSFile);
    }

    //Slick initialization
    $('.rotating-banner-slot').on('init', function() {
        $('.rotating-banner-slot').find('.slick-list').removeAttr('aria-live');
        $('.rotating-banner-slot').find('a').removeAttr('title');
        /*setTimeout(function() {
            $('.rotating-banner-slot').find('.slick-track').removeAttr('role');
            $('.rotating-banner-slot').find('.slick-slide').removeAttr('role');
        }, 100);*/
    });

    // vertical infinite slider
    $('.rotating-banner-slot').slick({
        slide: '.navigational-promo-asset',
        infinite: true,
        autoplay: true,
        swipe: false,
        draggable: false,
        arrows: false,
        vertical: true,
        autoplaySpeed: rotationInterval,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: false,
        rows: 0
    });
}

function initDynamicErrorsAlert() {
    // Code for screen reader users to navigate through a form using the 'Tab' key

    // Listen for the 'keydown' event on the document
    document.addEventListener('keydown', function (event) {
    // If the key pressed was not 'Tab', ignore the event
    if (event.keyCode !== 9) return;

    // Get the element that the event originated from
    let element = event.target;

    // If the element exists
    if(element) {
        let ariaDescribedby = element.getAttribute('aria-describedby');
        let nextElement = document.getElementById(ariaDescribedby);

        // If the nextElement exists
        if(nextElement) {
            element.blur();
            nextElement.setAttribute('aria-live', 'polite');
        }
    }
    });
}

/**
 * WISHLIST ANNOUNCEMENT: for products
 * @param {Announcement message - is product added to wishlist?}} message 
 * @param {Status - 'alert-success' : 'alert-danger'} status 
 */
SiteAccessibility.wishListAnnouncement = function(message, status){
    
    // Escape message to prevent XSS
    const safeMsg = $('<div>').text(message).html();

    // Ensure container exists
    if (!$('.add-to-wishlist-messages').length) {
        $('body').append(`
            <div class="add-to-wishlist-messages text-center" aria-hidden="false"></div>
        `);
    } else {
        // Update message text and title safely
        const $status = $('.add-to-wishlist-messages .status');
        $status.attr('title', safeMsg).text(`${safeMsg}`);
    }

    const $messageRegion = $('.add-to-wishlist-messages');
    const $alert = $(`
        <div class="add-to-wishlist-alert text-center ${status}"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            tabindex="-1"
            title="${safeMsg}">
            ${safeMsg}
        </div>
    `);


    $messageRegion.find('.add-to-wishlist-alert').remove();
    $messageRegion.append($alert);
    $alert.focus();
    setTimeout(function () {
        // On messageRegion close → restore focus to trigger and clear live region
        $messageRegion.remove();
        restoreFocusOnToDisabledTrigger();
    }, 5000)

}

/**
 * Restores focus to the wishlist trigger button after live announcement close.
 * Supports disabled buttons by temporarily enabling them for focus.
 */
function restoreFocusOnToDisabledTrigger() {
    if (SiteAccessibility.lastTriggerButton && SiteAccessibility.lastTriggerButton.length) {
        const $btn = SiteAccessibility.lastTriggerButton;
        const wasDisabled = $btn.prop('disabled');

        //making disabled
        if (wasDisabled) {
            $btn.prop('disabled', false);
        }

        // Native focus with preventScroll for accessibility
        $btn[0].focus({ preventScroll: true });

        if (wasDisabled) {
            // Re-disables the button after a short delay to avoid flicker or unintended clicks.
            setTimeout(() => $btn.prop('disabled', true), 10000);
        }
    }
}


/**
 * Announces a status update to screen readers when a filter is selected.
 * @param {HTMLElement} sourceElement - The parent element containing the live region 
 * where the status message will be updated.
 */
SiteAccessibility.updatesAnnouncement = function (sourceElement) {
    const $source = $(sourceElement).find('.source-count');
    const $liveRegion = $(sourceElement).find('.status-live-region');

    if (!$source.length || !$liveRegion.length) return;

    const message = `${$source.html().trim()}`;

    // Clear live region to force re-announcement
    $liveRegion.html(null);

    // Use requestAnimationFrame for smoother timing
    requestAnimationFrame(() => {
        setTimeout(() => {
            $liveRegion.html(message);
        }, 100); // Shorter delay improves responsiveness
    });
};

/**
 * Announces cart status updates to screen readers via a live region.
 * Ensures the live region exists, clears it, and updates it with the new message.
 *
 * Usage example:
 * SiteAccessibility.updatesAnnouncementCart("add | remove", totalQuantity, sourceElement);
 * @param {string} action - The cart action performed ("add" or "remove").
 * @param {number|string} totalQuantity - Current total quantity in the cart.
 * @param {HTMLElement|jQuery|string} sourceElement - Parent element containing the live region.
 */
SiteAccessibility.updatesAnnouncementCart = function (action, totalQuantity) {
    const $source = $('.minicart-link');
    if (!$source.length) return; // Exit if source not found

    const qty = Number(totalQuantity) || 0;
    let message = '';

    switch (action) {
        case 'add':
            message = `Item added to cart. Total items in cart: ${qty}`;
            break;
        case 'remove':
            message = `Item removed from cart. Total items in cart: ${qty}`;
            break;
        default:
            message = 'Add an item to the cart to begin.';
    }

    const $liveRegion = $source.find('.live-region-status');
    if (!$liveRegion.length) return; // Exit if live region not found

    $liveRegion.empty();
    requestAnimationFrame(() => {
        setTimeout(() => $liveRegion.text(message), 100);
    });
};


/**
 * Stores the modal trigger element to restore focus after close.
 */
$(document).on('click', `[data-toggle="modal"], [data-toggle="add-to-wish-list"]`, function () {
    SiteAccessibility.lastTriggerButton = $(this).closest('[data-toggle="modal"], [data-toggle="add-to-wish-list"]');
});


/**
 * Enhances modal accessibility: announces via live region and focuses the Close button on modal open.
 * Traps focus within the modal, supports Esc to close, and restores focus after closing.
 */
SiteAccessibility.focusTrapModalHandler = function (modalSelector) {
    var keydownHandler = function (e) {
        var $modal = $(modalSelector + ':visible');
        if (!$modal.length) return;

        var $focusable = $modal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
            .filter(':visible');
        var firstEl = $focusable[0];
        var lastEl = $focusable[$focusable.length - 1];
        var $active = $(document.activeElement);

        // Trap focus with Tab / Shift+Tab
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === firstEl) {
                e.preventDefault();
                $(lastEl).focus();
            } else if (!e.shiftKey && document.activeElement === lastEl) {
                e.preventDefault();
                $(firstEl).focus();
            }
        }

        // Handle Enter on close button without shifting focus
        else if (e.key === 'Enter' && $active.is('.close, [data-dismiss="modal"]')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $active.trigger('click');
        }

        // Escape closes modal
        else if (e.key === 'Escape') {
            $modal.modal('hide');
        }
    };

    // On modal open
    $(modalSelector).on('shown.bs.modal', function () {
        $(this).find('.close, [data-dismiss="modal"]').first().focus();
        $(document).on('keydown.modalFocusTrap', keydownHandler);
    });

    // On modal close
    $(modalSelector).on('hidden.bs.modal', function () {
        $(document).off('keydown.modalFocusTrap');
        if (SiteAccessibility.lastTriggerButton) {
            SiteAccessibility.lastTriggerButton.focus();
        }
        SiteAccessibility.lastTriggerButton = null;
    });
};


/**
 * Ensures all anchor elements have accessible text:
 *    • Adds a visually hidden label when links are empty (no text and no children).
 *    • Adds a visually hidden label when links contain only icons (SVG/img) without visible text.
 */

SiteAccessibility.fillEmptyLinks = function () {
    $(document).ready(function () {
        $('a').each(function () {
            var $link = $(this);

            // Check for visible text and child elements
            var hasVisibleText = $.trim($link.text()).length > 0;
            var hasChildren = $link.children().length > 0;

            // Case 1: Empty link (no text, no children)
            if (!hasVisibleText && !hasChildren) {
                $link.append('<span class="visually-hidden sr-only">Link</span>');
            }
            // Case 2: Link with only icon(s) but no visible text
            else if (!hasVisibleText && hasChildren) {
                if (!$link.find('.visually-hidden').length) {
                    $link.append('<span class="visually-hidden sr-only">Link</span>');
                }
            }
        });
    });
};
SiteAccessibility.fillEmptyLinks();